import React from 'react';

import { AppContextProvider } from '@contexts/AppContext';
import { AboutProps } from '@utils/aboutInterfaces';

import Address from './Address';
import BrandPartner from './BrandPartner';
import ContactUs from './ContactUs';
import Header from './Header';
import LetterFromEditor from './LetterFromEditor';
import OurTeam from './OurTeam';
import Testimonials from './Testimonials';

const About = ({ canSendMessage, env, initialCurrentUser, isWebview, team }: AboutProps) => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <div className="px-16 sm:px-28">
        <Header />
        <div className="relative mx-auto max-w-[1060px]">
          <div className="mb-24  px-0 sm:mb-48 lg:mb-72 lg:px-[27px]">
            <LetterFromEditor />
            <Testimonials className="mt-48 md:mt-80 " />
            <OurTeam team={team} canSendMessage={canSendMessage} />
            <BrandPartner />
            <Address />
            <div className="my-48 flex w-full items-end border-0 border-b border-solid border-grayscale-gray sm:my-80 sm:items-center"></div>
            <ContactUs />
          </div>
        </div>
      </div>
    </AppContextProvider>
  );
};

export default About;
